import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "@/components/site/Page";
import { CookiePolicyContent } from "@/components/site/PolicyCookieSection";
import { getCookiePolicyContent } from "@/lib/cookie-policy.functions";
import { absoluteUrl, ogImage, seoLinks } from "@/lib/seo";

const title = "Cookie policy | Swedish International School";
const description =
  "Which cookies and storage sweintschool.com uses, why, for how long and how to change your choice.";

export const Route = createFileRoute("/en/cookie-policy")({
  loader: () => getCookiePolicyContent({ data: { locale: "en" } }),
  errorComponent: () => <PolicyLoadError message="The cookie policy could not be loaded." />,
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/en/cookie-policy") },
      { name: "twitter:card", content: "summary" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks("/en/cookie-policy"),
  }),
  component: CookiePolicyPage,
});

function CookiePolicyPage() {
  const policy = Route.useLoaderData();
  return (
    <>
      <PageHero eyebrow="Privacy" title="Cookie policy" intro="Which cookies we use, why, and how to change your choice." />
      <PolicyBody>
        <CookiePolicyContent locale="en" body={policy.body} />
      </PolicyBody>
    </>
  );
}

function PolicyLoadError({ message }: { message: string }) {
  return <main className="mx-auto max-w-3xl px-4 py-24"><p role="alert">{message}</p></main>;
}
